// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bDm54rx8Q9Fseqjv8pLq{background-color:#ffc500;border:solid 1px rgba(14,25,26,.25);border-radius:3px;box-shadow:0 3px 12px 0 rgba(14,25,26,.3);box-sizing:border-box;height:324px;inset:0;margin:auto;padding:10px;position:absolute;width:600px;z-index:10}@media only screen and (min-width: 450px){.bDm54rx8Q9Fseqjv8pLq{padding:20px}}.RGrBvYOre5eQqv2bgQWw{background-position:100% 0;background-repeat:no-repeat;background-size:360px auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `bDm54rx8Q9Fseqjv8pLq`,
	"backgroundImage": `RGrBvYOre5eQqv2bgQWw`
};
export default ___CSS_LOADER_EXPORT___;
